import {
  GET_PAYMENT_HISTORY_FAILURE,
  GET_PAYMENT_HISTORY_REQUEST,
  GET_PAYMENT_HISTORY_SUCCESS,
} from "../actions/paymentHistoryAction";

const initialState = {
  loading: false,
  paymentHistory: {},
  error: null,
};

export const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_HISTORY_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_PAYMENT_HISTORY_SUCCESS:
      // console.log("=-=-=-=-=-=-=-", JSON.stringify(action.payload, null, 12));

      return { ...state, loading: false, paymentHistory: action.payload };

    case GET_PAYMENT_HISTORY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
